import { render, staticRenderFns } from "./buttonSub.vue?vue&type=template&id=cadaeca8&"
import script from "./buttonSub.vue?vue&type=script&lang=js&"
export * from "./buttonSub.vue?vue&type=script&lang=js&"
import style0 from "./buttonSub.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports